export default "__VITE_ASSET__CxzWYt0q__"